var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignupSucessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216.758,
    height: 241.081,
    viewBox: "0 0 216.758 241.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#ffad00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ff9400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#ff8500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff8000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3124",
    "data-name": "Group 3124",
    transform: "translate(-575.303 -150.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Signed_up_",
    "data-name": "Signed up ",
    transform: "translate(22.761 -14.563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_certification_re_ifll",
    transform: "translate(566.061 165.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M426.5,254.159a46.034,46.034,0,0,1-5.06,1.6c-2.267.552-3.547.809-5.735-.041-.077-.03-.15-.059-.219-.088a23.242,23.242,0,0,1-14.146-21.075c-.011-.155-.011-.317-.011-.476a22.657,22.657,0,0,1,.109-2.287,23.112,23.112,0,0,1,.5-3.076l-.022,0a8.452,8.452,0,0,1-2.227-6.786,11.216,11.216,0,0,1,5.066-8.387,17.743,17.743,0,0,1,7.366-2.6,18.658,18.658,0,0,1,2.118-.123h6.648a28.723,28.723,0,0,1,4.173-.658h.011c13.38-1.11,23.933,7.761,22.948,18.554-.007.012-.018.024-.026.036-.284.464-.536.9-.758,1.324-.215.392-.4.769-.554,1.126-1.221,2.759,4.582,45.56,2.5,46.21-1.185.369-5.959-31.481-5.1-25.424C445.154,259.582,432.663,251.88,426.5,254.159Z",
    transform: "translate(-364.838 -200.324)",
    fill: "#722d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M125.807,387.29,144.355,426.8l-71.35-7.226L87.9,381.645Z",
    transform: "translate(-43.989 -256.083)",
    fill: "#ffb6b6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M464.786,622.092a103.93,103.93,0,0,1-38.54,5.162l-5.678-9.208s-.238,3.429-.592,8.672a100.255,100.255,0,0,1-18.323-3.885c-11.327-3.542-21.945-9.031-32.709-14.092-2.18-13-3-33.035,9.055-44.7l64.873,11.887s10.409,7.785,7.624,10.574-3.216,2.353-1.386,4.183,5.783,4.276,5.823,5.875C454.95,597.185,459.387,608.512,464.786,622.092Z",
    transform: "translate(-345.735 -411.66)",
    fill: "#3d5656"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M428.554,322.007,412.881,323.1l-10.13,9.789-3.548.633a13.227,13.227,0,0,0-10.882,13.8c.73,12.364,2.364,30.838,5.779,36.832,5.3,9.294,9.669,6.378,5.3,9.294s-7.31.625-5.3,5.233-2.723,10.519-2.723,10.519l-1.886,1.886,2,.82,63.747,8.295s-5.512-24.783-2.065-30.871,11.805-24.491,4.346-31.692l-7.294-25.667-12.546-3.7Z",
    transform: "translate(-358.065 -267.157)",
    fill: "#fed049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M669.146,517.35a7.246,7.246,0,0,1-6.883-8.626l-29.9-20.251,3.568-9.648,35.34,24.312a7.236,7.236,0,0,1-2.123,14.213Z",
    transform: "translate(-503.779 -360.783)",
    fill: "#ffcfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M507.612,341.851l-4.345,1.721,23.179,45.271,47.985,32.708,6.917-11.691-36.526-31.55L530.2,350.264A18,18,0,0,0,507.612,341.851Z",
    transform: "translate(-426.706 -278.248)",
    fill: "#fed049"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_127",
    "data-name": "Ellipse 127",
    cx: 15.738,
    cy: 15.738,
    r: 15.738,
    transform: "translate(46.099 19.393)",
    fill: "#ffcfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M440.341,233.756c-.262.138-.521.266-.784.394s-.547.262-.824.386c-5.267,2.387-9.557,2.654-12.16-.78a14.577,14.577,0,0,0-1.2-5.241,8.423,8.423,0,0,1-1.389,5.241h-5.241c-5.4,3.583-8.168,6.874-4.421,18.637.244.773,1.917,28.226,2.395,30.337-8.172-3.135-15.221-36.417-15.4-45.186-.011-.142-.011-.292-.011-.437a19.165,19.165,0,0,1,.109-2.1,19.687,19.687,0,0,1,.5-2.828l-.022,0a7.387,7.387,0,0,1-2.227-6.24,18,18,0,0,1,5-4.483,31.911,31.911,0,0,1,5.475-2.056l.135-.033c.576-.157,1.166-.3,1.757-.423a32.993,32.993,0,0,1,3.685-.558c.091,0,.179-.011.259-.011a2.761,2.761,0,0,1,1.407.386s0,0,.011,0a2.776,2.776,0,0,1,1.352,2.362h5.839c.215,0,.43.007.645.018,8.132.324,14.667,3.8,15.086,11.8C440.333,233.209,440.341,233.479,440.341,233.756Z",
    transform: "translate(-364.818 -205.28)",
    fill: "#722d54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_128",
    "data-name": "Ellipse 128",
    cx: 10.368,
    cy: 10.368,
    r: 10.368,
    transform: "translate(30.632 8.372)",
    fill: "#722d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M420.064,199.835a10.246,10.246,0,0,1-12.549,7.584,10.368,10.368,0,0,1-7.584-12.549c1.371-5.56,8.118-3.957,12.549-7.584C418.747,182.154,421.652,192.278,420.064,199.835Z",
    transform: "translate(-364.828 -185.891)",
    fill: "#722d54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M391.43,466.55c8.837-36.036,26.346-67.01,55.344-91.277a8.158,8.158,0,0,1,11.193-2.743l68.934,41.8a8.158,8.158,0,0,1,2.743,11.193C518.576,462.5,502,494.582,474.3,516.8a8.158,8.158,0,0,1-11.193,2.743l-68.934-41.8A8.158,8.158,0,0,1,391.43,466.55Z",
    transform: "translate(-359.231 -296.617)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M403.682,478.694a8.158,8.158,0,0,1-2.743-11.193c8.837-36.036,26.346-67.01,55.344-91.277a8.053,8.053,0,0,1,3.041-2.872l-1.356-.823a8.158,8.158,0,0,0-11.193,2.743c-29,24.268-46.507,55.241-55.344,91.277a8.158,8.158,0,0,0,2.743,11.193l68.935,41.8a8.122,8.122,0,0,0,8.153.129Z",
    transform: "translate(-359.231 -296.617)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M553.319,537.547l-46.272-27.881a3.241,3.241,0,0,1,3.346-5.553l46.272,27.881a3.241,3.241,0,0,1-3.346,5.553Z",
    transform: "translate(-428.026 -375.603)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M539.981,478.009l-10.18-6.134a3.241,3.241,0,0,1,3.328-5.563l.017.011,10.18,6.134a3.241,3.241,0,0,1-3.346,5.553Z",
    transform: "translate(-441.605 -353.037)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M535.065,567.833l-46.272-27.881a3.241,3.241,0,0,1,3.339-5.557l.007,0,46.272,27.881a3.241,3.241,0,1,1-3.346,5.553Z",
    transform: "translate(-417.125 -393.684)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_129",
    "data-name": "Ellipse 129",
    cx: 8.088,
    cy: 8.088,
    r: 8.088,
    transform: "translate(123.082 87.772)",
    fill: "#3d5656"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 28.887,
    cy: 28.887,
    r: 28.887,
    transform: "translate(78.987 182.905)",
    fill: "#2ec973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M537.576,697.368a29.29,29.29,0,1,1,29.289-29.29,29.29,29.29,0,0,1-29.289,29.29Zm0-57.773a28.484,28.484,0,1,0,28.484,28.484A28.484,28.484,0,0,0,537.576,639.595Z",
    transform: "translate(-429.702 -456.287)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M554.755,704.232a3.212,3.212,0,0,1-2.57-1.286L544.3,692.439a3.213,3.213,0,0,1,5.141-3.856l5.156,6.874,13.242-19.863a3.213,3.213,0,0,1,5.347,3.565L557.429,702.8a3.214,3.214,0,0,1-2.584,1.43Z",
    transform: "translate(-450.822 -477.406)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 2.086,
    cy: 1.451,
    rx: 2.086,
    ry: 1.451,
    transform: "translate(198.835 62.695) rotate(-4.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 1.451,
    cy: 2.086,
    rx: 1.451,
    ry: 2.086,
    transform: "translate(143.441 6.08) rotate(-75.779)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M365.548,533.571a7.685,7.685,0,0,1-3.641-11.124L339.7,491.233l7.124-8.265,26.1,37.266a7.675,7.675,0,0,1-7.38,13.337Z",
    transform: "translate(-329.051 -363.256)",
    fill: "#ffcfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M350.279,361.951h0a5.48,5.48,0,0,0-7,1.233l-30,41.96,27.8,39.491,10.88-11.686-16.924-26.6,22.493-21.416a18,18,0,0,0-7.246-22.987Z",
    transform: "translate(-313.272 -290.553)",
    fill: "#fed049"
  })), /*#__PURE__*/React.createElement("g", {
    id: "undraw_circled-arrow",
    transform: "translate(562.871 352.745) rotate(34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M.228,1.224A21.9,21.9,0,0,0,14.071,24.913a21.9,21.9,0,0,0,14.683.17c4.963-1.768,9.818-6,8.761-11.816a8.45,8.45,0,0,0-5.142-5.99C29.19,5.9,25.7,6.249,22.4,6.978c-2.109.466-1.217,3.7.893,3.238a13.573,13.573,0,0,1,7.212-.085,5.461,5.461,0,0,1,3.626,3.379c1.249,4.291-3.292,7.38-6.758,8.5A18.463,18.463,0,0,1,6.333,14.678,18.7,18.7,0,0,1,3.466,2.117,1.735,1.735,0,0,0,2.294.051,1.691,1.691,0,0,0,.228,1.224h0Z",
    transform: "translate(6.052 1.177)",
    fill: "#90c8ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M3.133,12.03l6.313-9.52L6.81,2.85l8.169,7.426a1.716,1.716,0,0,0,2.375,0,1.7,1.7,0,0,0,0-2.375L9.184.476a1.706,1.706,0,0,0-2.637.34L.234,10.335a1.7,1.7,0,0,0,.6,2.3,1.71,1.71,0,0,0,2.3-.6h0Z",
    transform: "translate(0 0)",
    fill: "#90c8ac"
  })), /*#__PURE__*/React.createElement("g", {
    id: "undraw_chat-text",
    transform: "translate(673.203 172.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M21.389,39.854c-5.029,2.762-10.431,4.583-16.226,4.3l1.524,3.679a26.418,26.418,0,0,0,7.39-10.843,2.194,2.194,0,0,0-1.505-2.651c-5.809-2.079-9.19-9.02-8.12-14.95C5.691,12.526,11.313,7.1,17.883,5.163A20.443,20.443,0,0,1,38.721,10.6,18.113,18.113,0,0,1,42.215,29.98a16.646,16.646,0,0,1-8.075,8.444A18,18,0,0,1,23.05,39.637,2.22,2.22,0,0,0,20.4,41.142,2.173,2.173,0,0,0,21.9,43.794a27.157,27.157,0,0,0,6,.542,21.33,21.33,0,0,0,6.659-1.426,20.805,20.805,0,0,0,10.1-8.349,22.231,22.231,0,0,0-.843-24.478A24.56,24.56,0,0,0,19.589.353C11.12,1.749,3.428,7.845.819,16.126-1.967,24.97,2.547,35.319,11.426,38.5L9.921,35.846a21.962,21.962,0,0,1-6.282,8.941c-1.467,1.318-.234,3.594,1.524,3.679,6.533.317,12.737-1.778,18.4-4.89,2.432-1.336.26-5.06-2.176-3.722Z",
    transform: "translate(0 0)",
    fill: "#ffb3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M16.778,21.429,17.687,19l-3.6.951c1.869,1.97,3.987,4.074,6.728,4.707a6.963,6.963,0,0,0,7.25-2.283c.125-.168.726-1.05.731-1.045l-.919.229q-.433-.287-.008.083a5.771,5.771,0,0,0,.343.5,4.52,4.52,0,0,0,3.7,2.19c3.237,0,4.794-2.9,5.6-5.6.8-2.663-3.361-3.8-4.157-1.146-.215.719-.431,1.9-1.123,2.338-.4.251-.35-.043-.628-.433a4.712,4.712,0,0,0-2.854-2.128A3.487,3.487,0,0,0,25.239,18.9c-.461.618-.691,1.214-1.4,1.5a3.472,3.472,0,0,1-1.743.126c-2.053-.363-3.606-2.2-4.964-3.627a2.181,2.181,0,0,0-3.6.951l-.909,2.432a2.174,2.174,0,0,0,1.505,2.651,2.2,2.2,0,0,0,2.651-1.505h0Z",
    transform: "translate(-1.726 -2.216)",
    fill: "#ffb3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M21.244,30.209a1.436,1.436,0,0,1-.439,1.883,1.254,1.254,0,0,1-1.186.018c.39.2-.192-.27.1.078q.123.126.234.261-.207-.276-.074-.1c.2.08.412.546.584.75a4.189,4.189,0,0,0,.326.35,3.941,3.941,0,0,0,1.6.955c1.678.455,3.07-.378,4.23-1.509.187-.182.369-.368.562-.542q.065-.06.132-.117.258-.214-.169.123a2.816,2.816,0,0,1,.275-.178c.285-.243-.468.148-.132.055q.331-.075-.27.027.337,0-.255-.054l.143.036a.836.836,0,0,1-.453-.273,1.536,1.536,0,0,1,.158.152q.159.174-.1-.146c.224.14.415.713.532.941a5.851,5.851,0,0,0,.485.795,3.9,3.9,0,0,0,3.084,1.772,2.171,2.171,0,0,0,2.155-2.155,2.2,2.2,0,0,0-2.155-2.155.976.976,0,0,1,.533.168q-.294-.177.078.092a2.33,2.33,0,0,1-.212-.215q.261.354.058.062c-.2-.36-.385-.73-.589-1.087a4.245,4.245,0,0,0-2.574-2.144c-1.887-.479-3.255.775-4.51,1.961a3.659,3.659,0,0,0-.351.313q.434-.325.166-.133-.09.061-.184.115c-.27.226.487-.15.132-.054q-.331.076.27-.025-.337,0,.254.055-.346-.1.086.056-.293-.191.065.059c-.087,0-.384-.4-.427-.475q.267.345.038.047l-.337-.436a4.707,4.707,0,0,0-.469-.518,3.393,3.393,0,0,0-4.014-.649,2.9,2.9,0,0,0-1.108,4.015,2.156,2.156,0,1,0,3.722-2.176h0Z",
    transform: "translate(-2.358 -3.854)",
    fill: "#ffb3b3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "undraw_pointer",
    d: "M3.241,27.77,2.786,1.35.408,2.334,19.424,18.845l1.355-2.328q-3.358-.869-6.722-1.715c-1.976-.5-4.338-1.339-5.872.533A17.914,17.914,0,0,0,6.578,18.02L4.816,21.171,1.427,27.23C.551,28.8,2.956,30.2,3.832,28.636,5.865,25,7.875,21.35,9.932,17.729c.316-.557.447-.876,1.127-.787a25,25,0,0,1,2.8.682q3.095.78,6.184,1.58c1.277.331,2.447-1.38,1.355-2.328L2.378.365A1.411,1.411,0,0,0,0,1.35L.455,27.77a1.394,1.394,0,0,0,2.785,0h0Z",
    transform: "translate(747.474 271.072)",
    fill: "#af7ab3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3123",
    "data-name": "Group 3123",
    transform: "translate(-1188 1974.211)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_898",
    "data-name": "Rectangle 898",
    width: 3.526,
    height: 1.322,
    rx: 0.661,
    transform: "translate(1871.805 -1723.779)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_899",
    "data-name": "Rectangle 899",
    width: 3.526,
    height: 1.322,
    rx: 0.661,
    transform: "translate(1871.803 -1731.111)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_900",
    "data-name": "Rectangle 900",
    width: 3.526,
    height: 1.322,
    rx: 0.661,
    transform: "translate(1870 -1727.469)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M1167.837,386.352c-1.686-.447-2.722.392-4.337.722l2.841,2.841a1.36,1.36,0,0,1,.379.677c.018-.059.036-.113.053-.162,1.153-3.25,3.239-2.213,3.239-2.213A3.047,3.047,0,0,0,1167.837,386.352Z",
    transform: "translate(719.307 -2116.065)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M464.8,203.028l5.721,5.436a1.128,1.128,0,0,1,.041,1.594l-5.813,6.118a.241.241,0,0,1-.415-.159l-.066-2.608-4.9-4.66a1.127,1.127,0,0,1-.041-1.594l3.883-4.086A1.127,1.127,0,0,1,464.8,203.028Zm1.259,7.674a.775.775,0,1,0-.241-.542A.775.775,0,0,0,466.064,210.7Zm-1.686-1.6a.776.776,0,1,0-.028-1.1A.776.776,0,0,0,464.378,209.1Zm-1.686-1.6a.776.776,0,1,0-.028-1.1A.776.776,0,0,0,462.691,207.5Z",
    transform: "translate(1415.315 -1934.767)",
    fill: "#1450ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupSucessIcon);
export default __webpack_public_path__ + "static/media/signup-sucess-icon.37e31690160bedc68be299774b5b4813.svg";
export { ForwardRef as ReactComponent };